<template>
  <div class="flex items-center gap-2 px-2 transition-all delay-300 ease-in-out" v-if="loading">
    <Loader v-if="loading" size="16" class="animate-spin text-gray-400" />
    <span v-if="appStore.loadingDisplayText" class="text-gray-400">{{ appStore.loadingDisplayText }}</span>
  </div>
</template>
<script setup>
import { useAppStore } from '@/stores/appStore';
import { useToast } from '@disguise/cloud-ui';
import { Loader } from 'lucide-vue-next';

import { onBeforeUnmount, ref, watch } from 'vue';

const appStore = useAppStore();
const loading = ref(false);
const timeoutId = ref(null);
const toast = useToast();

const clearPendingTimeout = () => {
  if (timeoutId.value) {
    clearTimeout(timeoutId.value);
    timeoutId.value = null;
  }
};

watch(
  () => appStore.loading,
  (newVal) => {
    if (newVal) {
      if (timeoutId.value) clearPendingTimeout();
      if (appStore.displayLoadingToast) {
        toast.add({
          group: 'br',
          detail: appStore.loadingDisplayText || 'Loading...',
          severity: 'loading',
          life: 3000,
        });
      }
      loading.value = true;
    } else {
      clearPendingTimeout();
      timeoutId.value = setTimeout(() => {
        loading.value = false;
        appStore.setDisplayText(null);
        appStore.setDisplayLoadingToast(false);
        timeoutId.value = null;
      }, 1000);
    }
  },
  { immediate: true }
);

watch(
  () => appStore.displayLoadingToast,
  (newVal) => {
    if (!newVal) toast.removeGroup('br');
  }
);

onBeforeUnmount(() => {
  clearPendingTimeout();
});
</script>
